import { ButtonColor } from "@/common/enum/button-color";
import { Button, Modal } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { itemService } from "../../services/item-service";
import { HistoryDto } from "../../types/dto/history-dto";
import { HistoryTable } from "../table/history-table/HistoryTable";
import { H4 } from "../typography/H4";

interface Props {
  itemId: number;
  closeModal: () => void;
}

export const ItemDetailHistoryModal: React.FC<Props> = ({
  itemId,
  closeModal,
}) => {
  const [patchnote, setPatchnote] = useState<HistoryDto[]>([]);

  const getPatchnote = async () => {
    const response = await itemService.getItemDetailPatchNote(itemId);
    setPatchnote(response.data);
  };

  useEffect(() => {
    getPatchnote();
  }, []);

  return (
    <Modal size="4xl" show={true} onClose={closeModal}>
      <Modal.Header className="p-[24px] h-[76px]">
        <H4>상품 수정 이력</H4>
      </Modal.Header>
      <Modal.Body className="overflow-visible">
        <HistoryTable history={patchnote} />
      </Modal.Body>
      <Modal.Footer>
        <Button
          color={ButtonColor.TRANSPARENT_OUTLINE}
          onClick={closeModal}
          // size={"xl"}
        >
          닫기
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
